/* SD Cart Drawer — vervangt Upcart (Scott and Daughters)
   - opent bij add-to-cart (formulieren én andere scripts die /cart/add aanroepen)
   - ververst de sectie 'sd-cart-drawer' via de Section Rendering API
   - aantallen, verwijderen, timer in de announcement */
(function () {
  'use strict';
  if (window.SDCart) return;

  var SECTION = 'sd-cart-drawer';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  /* Eigen verzoeken lopen via window.fetch zoals die op dat moment is, zodat
     andere scripts die fetch omwikkelen (LASSO-checkout, tracking) ze ook zien. */
  function cartFetch(url, opts) { return window.fetch(url, opts); }
  var internal = 0;
  var timerHandle = null;

  function root() { return document.querySelector('[data-sd-cart]'); }
  function isCartUrl(url, kinds) {
    url = String(url || '');
    return kinds.some(function (k) { return url.indexOf('/cart/' + k) > -1; });
  }

  function swap(html) {
    var el = root(); if (!el || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-sd-cart-inner]');
    var current = el.querySelector('[data-sd-cart-inner]');
    if (fresh && current) current.replaceWith(fresh);
    updateCounts(Number((fresh || current).dataset.count || 0));
    startTimer();
  }

  function updateCounts(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = n; node.hidden = n === 0;
    });
  }

  function refresh() {
    internal++;
    return cartFetch(ROOT + '?sections=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) { swap(d[SECTION]); })
      .catch(function (e) { console.error('[SDCart]', e); })
      .finally(function () { internal--; setLoading(false); });
  }

  function setLoading(on) {
    var el = root(); if (!el) return;
    el.classList.toggle('is-loading', !!on && el.dataset.loadingPreview === 'true');
  }

  var lastFocus = null;
  function open() {
    var el = root(); if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sd-cart-open');
    var c = el.querySelector('.sd-cart__close'); if (c) c.focus({ preventScroll: true });
    document.dispatchEvent(new CustomEvent('sd-cart:open'));
  }
  function close() {
    var el = root(); if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sd-cart-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function openOnAdd() { var el = root(); return !el || el.dataset.openOnAdd !== 'false'; }

  function afterAdd() {
    if (openOnAdd()) { setLoading(true); open(); }
    return refresh();
  }

  function change(key, quantity) {
    var line = root().querySelector('[data-sd-line="' + CSS.escape(key) + '"]');
    if (line) line.classList.add('is-pending');
    internal++;
    return cartFetch(ROOT + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: SECTION })
    }).then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.sections && d.sections[SECTION]) swap(d.sections[SECTION]); else return refresh();
        document.dispatchEvent(new CustomEvent('sd-cart:change'));
      })
      .catch(function () { return refresh(); })
      .finally(function () { internal--; });
  }

  /* ---- Product forms ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (!form.matches('[data-product-form]') && action.indexOf('/cart/add') === -1) return;
    if (e.submitter && e.submitter.name && e.submitter.name !== 'add') return;
    e.preventDefault();

    var btn = e.submitter || form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-add-to-cart-error]');
    if (err) { err.hidden = true; err.textContent = ''; }
    if (btn) btn.disabled = true;

    var fd = new FormData(form);
    fd.append('sections', SECTION);
    internal++;
    cartFetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d && (res.d.description || res.d.message) || '');
        if (openOnAdd()) open();
        if (res.d.sections && res.d.sections[SECTION]) swap(res.d.sections[SECTION]); else refresh();
        document.dispatchEvent(new CustomEvent('sd-cart:add'));
      })
      .catch(function (ex) {
        if (err) { err.textContent = ex.message || err.dataset.genericError || ''; err.hidden = false; }
        else { form.submit(); }
      })
      .finally(function () { internal--; if (btn) btn.disabled = false; });
  }, true);

  /* ---- Other scripts (bundles, quick add) that call the cart API ---- */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var p = nativeFetch(input, init);
    if (!internal && isCartUrl(url, ['add', 'change', 'update', 'clear'])) {
      p.then(function (r) {
        if (!r.ok) return;
        if (isCartUrl(url, ['add'])) afterAdd(); else refresh();
      });
    }
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (!internal && isCartUrl(url, ['add', 'change', 'update', 'clear'])) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) { if (isCartUrl(url, ['add'])) afterAdd(); else refresh(); }
      });
    }
    return xOpen.apply(this, arguments);
  };

  /* ---- Clicks ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var toggle = t.closest('[data-cart-toggle], [data-sd-cart-open]');
    if (toggle) { e.preventDefault(); open(); refresh(); return; }
    var el = root(); if (!el || !el.contains(t)) return;

    if (t.closest('[data-sd-close]')) {
      if (t.closest('a[href]') && !t.closest('a[href]').getAttribute('href').startsWith('#')) { close(); return; }
      e.preventDefault(); close(); return;
    }
    var line = t.closest('[data-sd-line]'); if (!line) return;
    var key = line.dataset.sdLine;
    if (t.closest('[data-sd-remove]')) { change(key, 0); return; }
    var q = t.closest('[data-sd-qty]');
    if (q) {
      var input = line.querySelector('[data-sd-qty-input]');
      var next = Math.max(0, (Number(input.value) || 0) + Number(q.dataset.sdQty));
      input.value = next; change(key, next);
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-sd-qty-input]'); if (!input) return;
    var line = input.closest('[data-sd-line]');
    change(line.dataset.sdLine, Math.max(0, Number(input.value) || 0));
  });
  document.addEventListener('keydown', function (e) {
    var el = root();
    if (e.key === 'Escape' && el && el.classList.contains('is-open')) close();
  });

  /* ---- Announcement timer ({{timer}}, MM:SS, per bezoek) ---- */
  function startTimer() {
    clearInterval(timerHandle);
    var el = root(); if (!el) return;
    var nodes = el.querySelectorAll('[data-sd-timer]'); if (!nodes.length) return;
    var parts = String(el.dataset.timer || '00:00').split(':');
    var total = (Number(parts[0]) || 0) * 60 + (Number(parts[1]) || 0);
    if (!total) { nodes.forEach(function (n) { n.textContent = ''; }); return; }
    var KEY = 'sd_cart_timer_end', end;
    try { end = Number(sessionStorage.getItem(KEY)); } catch (x) {}
    if (!end || end < Date.now()) { end = Date.now() + total * 1000; try { sessionStorage.setItem(KEY, String(end)); } catch (x) {} }
    function tick() {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000));
      var txt = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
      nodes.forEach(function (n) { n.textContent = txt; });
      if (!left) clearInterval(timerHandle);
    }
    tick(); timerHandle = setInterval(tick, 1000);
  }

  window.SDCart = { open: open, close: close, refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startTimer); else startTimer();
})();
